import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '../assets/insure-daily-ax/company.png'
import _imports_1 from '../assets/insure-daily-ax/claim.png'
import _imports_2 from '../assets/insure-daily-ax/premium.png'
import _imports_3 from '../assets/insure-daily-ax/bill.png'
import _imports_4 from '../assets/insure-daily-ax/operate.png'
import _imports_5 from '../assets/insure-daily-ax/plan.png'
import _imports_6 from '../assets/insure-daily-ax/bank.png'


const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-left" }
const _hoisted_4 = { class: "card-long" }
const _hoisted_5 = { class: "card-content" }
const _hoisted_6 = { class: "card-echart" }
const _hoisted_7 = { class: "echart-app" }
const _hoisted_8 = { class: "echart-desc" }
const _hoisted_9 = { class: "echart-desc-value" }
const _hoisted_10 = { class: "echart-desc-text" }
const _hoisted_11 = {
  key: 0,
  class: "compare-icon"
}
const _hoisted_12 = {
  key: 1,
  class: "compare-icon"
}
const _hoisted_13 = {
  key: 2,
  class: "compare-icon"
}
const _hoisted_14 = { class: "echart-app" }
const _hoisted_15 = { class: "echart-desc" }
const _hoisted_16 = { class: "echart-desc-value" }
const _hoisted_17 = { class: "echart-desc-text" }
const _hoisted_18 = {
  key: 0,
  class: "compare-icon"
}
const _hoisted_19 = {
  key: 1,
  class: "compare-icon"
}
const _hoisted_20 = {
  key: 2,
  class: "compare-icon"
}
const _hoisted_21 = { class: "card-long card-other" }
const _hoisted_22 = { class: "card-content" }
const _hoisted_23 = { class: "card-module" }
const _hoisted_24 = { class: "card-right" }
const _hoisted_25 = { class: "card-short" }
const _hoisted_26 = { class: "card-account" }
const _hoisted_27 = { class: "account-info" }
const _hoisted_28 = { class: "account-info-detail" }
const _hoisted_29 = { class: "account-info-name" }
const _hoisted_30 = { class: "account-info-num" }
const _hoisted_31 = { class: "account-info-adress" }
const _hoisted_32 = { class: "account-value" }
const _hoisted_33 = { class: "bank-value" }
const _hoisted_34 = { class: "bank-button" }
const _hoisted_35 = { class: "card-short risk-content" }
const _hoisted_36 = { class: "card-content" }
const _hoisted_37 = { class: "risk-analysis" }
const _hoisted_38 = { class: "left-desc" }
const _hoisted_39 = { class: "left-desc-text" }
const _hoisted_40 = { class: "desc-text-item" }
const _hoisted_41 = { class: "desc-text-item" }
const _hoisted_42 = { class: "desc-text-item" }
const _hoisted_43 = { class: "table" }
const _hoisted_44 = { class: "table-top" }
const _hoisted_45 = { class: "table-btn" }
const _hoisted_46 = { class: "table-search" }
const _hoisted_47 = { class: "table-content" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "priceIptBox" }
const _hoisted_50 = { class: "priceIpt" }
const _hoisted_51 = { class: "dialog-footer" }
const _hoisted_52 = { class: "dialog-footer" }
const _hoisted_53 = { class: "project-content" }
const _hoisted_54 = { class: "project-card" }
const _hoisted_55 = { class: "project-item-left" }
const _hoisted_56 = { class: "project-item-left-name" }
const _hoisted_57 = { class: "project-item-left-desc project-item-left-time" }
const _hoisted_58 = { class: "project-item-left-desc" }
const _hoisted_59 = {
  key: 0,
  class: "project-item-btn project-item-btn-ok"
}
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "dialog-footer" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "text-red" }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaretTop = _resolveComponent("CaretTop")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_popupRecharge = _resolveComponent("popupRecharge")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_addInsure = _resolveComponent("addInsure")!
  const _component_feeRateNotice = _resolveComponent("feeRateNotice")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "card-title" }, "实时数据", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "echart-desc-text" }, "今日保费（元）", -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.realTimeData.premium), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[29] || (_cache[29] = _createElementVNode("span", { class: "compare-text" }, "较昨日", -1)),
                      (_ctx.realTimeData.premiumPercent > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _createVNode(_component_el_icon, { style: {"font-size":"16px","color":"#EA0000"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CaretTop)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.realTimeData.premiumPercent == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "--"))
                        : _createCommentVNode("", true),
                      (_ctx.realTimeData.premiumPercent < 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createVNode(_component_el_icon, { style: {"font-size":"16px","color":"#00D679"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CaretBottom)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(_ctx.realTimeData.premiumPercent ?
                                            `${Math.abs(_ctx.realTimeData.premiumPercent)}%` : '-'), 1)
                    ])
                  ]),
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "echart-dom" }, [
                    _createElementVNode("div", { id: "premium" })
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "echart-desc-text" }, "在保人数（人）", -1)),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.realTimeData.insureNum), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "compare-text" }, "较昨日", -1)),
                      (_ctx.realTimeData.insureNumPercent > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                            _createVNode(_component_el_icon, { style: {"font-size":"16px","color":"#EA0000"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CaretTop)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.realTimeData.insureNumPercent == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "--"))
                        : _createCommentVNode("", true),
                      (_ctx.realTimeData.insureNumPercent < 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                            _createVNode(_component_el_icon, { style: {"font-size":"16px","color":"#00D679"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CaretBottom)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(_ctx.realTimeData.insureNumPercent ?
                                            `${Math.abs(_ctx.realTimeData.insureNumPercent)}%` : '-'), 1)
                    ])
                  ]),
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "echart-dom" }, [
                    _createElementVNode("div", { id: "insureNum" })
                  ], -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "card-title" }, "常用应用", -1)),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: "module-app",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onModuleClick('company')))
                }, _cache[36] || (_cache[36] = [
                  _createElementVNode("div", { class: "module-app-img" }, [
                    _createElementVNode("img", {
                      class: "img-chart",
                      src: _imports_0
                    })
                  ], -1),
                  _createElementVNode("div", { class: "module-app-text" }, "派遣单位", -1)
                ])),
                _createElementVNode("div", {
                  class: "module-app",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onModuleClick('helpClaim')))
                }, _cache[37] || (_cache[37] = [
                  _createElementVNode("div", { class: "module-app-img" }, [
                    _createElementVNode("img", {
                      class: "img-chart",
                      src: _imports_1
                    })
                  ], -1),
                  _createElementVNode("div", { class: "module-app-text" }, "协助理赔", -1)
                ])),
                _createElementVNode("div", {
                  class: "module-app",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onModuleClick('insureValue')))
                }, _cache[38] || (_cache[38] = [
                  _createElementVNode("div", { class: "module-app-img" }, [
                    _createElementVNode("img", {
                      class: "img-chart",
                      src: _imports_2
                    })
                  ], -1),
                  _createElementVNode("div", { class: "module-app-text" }, "账单明细", -1)
                ])),
                _createElementVNode("div", {
                  class: "module-app",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onModuleClick('billInfo')))
                }, _cache[39] || (_cache[39] = [
                  _createElementVNode("div", { class: "module-app-img" }, [
                    _createElementVNode("img", {
                      class: "img-chart",
                      src: _imports_3
                    })
                  ], -1),
                  _createElementVNode("div", { class: "module-app-text" }, "交易记录", -1)
                ])),
                _createElementVNode("div", {
                  class: "module-app",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onModuleClick('operateRecord')))
                }, _cache[40] || (_cache[40] = [
                  _createElementVNode("div", { class: "module-app-img" }, [
                    _createElementVNode("img", {
                      class: "img-chart",
                      src: _imports_4
                    })
                  ], -1),
                  _createElementVNode("div", { class: "module-app-text" }, "操作记录", -1)
                ])),
                _createElementVNode("div", {
                  class: "module-app",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onModuleClick('insurePlan')))
                }, _cache[41] || (_cache[41] = [
                  _createElementVNode("div", { class: "module-app-img" }, [
                    _createElementVNode("img", {
                      class: "img-chart",
                      src: _imports_5
                    })
                  ], -1),
                  _createElementVNode("div", { class: "module-app-text" }, "保司方案", -1)
                ]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[43] || (_cache[43] = _createElementVNode("img", {
                      class: "bank-icon",
                      src: _imports_6
                    }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.bankInfo.openBank), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.bankInfo.bankNo), 1),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.bankInfo.bankName), 1)
                ]),
                _createElementVNode("div", {
                  class: "account-info-handle",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onCopyText && _ctx.onCopyText(...args)))
                }, [
                  _createVNode(_component_el_icon, { class: "fc-gary fs-16 check-box" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CopyDocument)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "account-line" }, null, -1)),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.balance), 1),
                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "bank-text" }, "账户余额（元）", -1))
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", {
                    class: "button button-normal",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onTransfer && _ctx.onTransfer(...args)))
                  }, "转账"),
                  _createElementVNode("div", {
                    class: "button button-success",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onRecharge && _ctx.onRecharge(...args)))
                  }, "充值")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[47] || (_cache[47] = _createElementVNode("div", { class: "card-title" }, "风险分析", -1)),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, "案件数：" + _toDisplayString(_ctx.premiumAndInsureData.caseCount), 1),
                    _createElementVNode("div", _hoisted_41, "赔偿金额：¥" + _toDisplayString(_ctx.premiumAndInsureData.finalMoney), 1),
                    _createElementVNode("div", _hoisted_42, "赔付率：" + _toDisplayString(_ctx.premiumAndInsureData.claimRate), 1)
                  ])
                ]),
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "echart-risk-box" }, [
                  _createElementVNode("div", {
                    id: "riskAnalysis",
                    style: {"width":"100%","height":"100%"}
                  })
                ], -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", {
            class: "table-title",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeProject()))
          }, [
            _createTextVNode(_toDisplayString(_ctx.projectName), 1),
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_CaretBottom)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_45, [
            (_ctx.projectId)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _ctx.onAddInsure
                }, {
                  default: _withCtx(() => _cache[48] || (_cache[48] = [
                    _createTextVNode(" 加保 ")
                  ])),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_el_form, {
            inline: true,
            model: _ctx.formSearch,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "员工" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formSearch.searchUserInfo,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formSearch.searchUserInfo) = $event)),
                    placeholder: "请输入出险姓名或身份证",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formSearch.policyStatus,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formSearch.policyStatus) = $event)),
                    placeholder: "请选择状态",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.policyStatusList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item.label,
                          value: item.value,
                          key: index
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "方案简称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formSearch.planId,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formSearch.planId) = $event)),
                    placeholder: "请选择方案",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planSearchList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item.label,
                          value: item.value,
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "生效日期" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.formSearch.date,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formSearch.date) = $event)),
                    type: "daterange",
                    class: "date-solt point",
                    "unlink-panels": "",
                    "range-separator": "至",
                    "start-placeholder": "生效日期",
                    "end-placeholder": "截止日期",
                    format: "YYYY-MM-DD",
                    "value-format": "YYYY-MM-DD",
                    style: {"width":"241px","margin-right":"20px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.onSearch
                  }, {
                    default: _withCtx(() => _cache[49] || (_cache[49] = [
                      _createTextVNode("搜索")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, { onClick: _ctx.onReset }, {
                    default: _withCtx(() => _cache[50] || (_cache[50] = [
                      _createTextVNode("重置")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createVNode(_component_el_table, {
            data: _ctx.tableData,
            height: "400px",
            style: {"width":"100%"},
            "header-cell-style": { background: '#FBFBFD' },
            ref: "dataTable",
            "header-row-style": { color: '#202536' },
            "row-style": { color: '#5E617D' },
            onSelectionChange: _ctx.handleSelectionChangeOne,
            "row-key": _ctx.rowKeyInit,
            type: "selection"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "userName",
                "reserve-selection": "",
                label: "员工姓名",
                width: "130px"
              }),
              _createVNode(_component_el_table_column, {
                class: "card-no",
                "reserve-selection": "",
                prop: "idCardNo",
                label: "身份证号"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (_ctx.onChangCardId(scope.row))
                  }, _toDisplayString(scope.row.cardNumShow ?
                                scope.row.idCardNo : scope.row.cardNumber), 9, _hoisted_48)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "insureStartTime",
                label: "在保时间",
                width: "200px"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", null, _toDisplayString(scope.row.insureStartTime) + " - " + _toDisplayString(_ctx.checkInsureEndTime(scope.row.insureEndTime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "policyStatus",
                label: "状态"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatter(scope.row.policyStatus, _ctx.policyStatusList, {
                                valueKey: 'value'
                                })), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "companyPlanName",
                label: "方案简称"
              }),
              _createVNode(_component_el_table_column, {
                prop: "serveCompanyName",
                label: "派遣单位"
              }),
              _createVNode(_component_el_table_column, {
                prop: "occupationOriginName",
                label: "工种"
              }),
              _createVNode(_component_el_table_column, {
                prop: "updateUserName",
                label: "操作人"
              }),
              _createVNode(_component_el_table_column, {
                prop: "updateTime",
                label: "最新更新时间"
              })
            ]),
            _: 1
          }, 8, ["data", "onSelectionChange", "row-key"]),
          _createVNode(_component_el_pagination, {
            class: "pagination",
            currentPage: _ctx.pageNum,
            "onUpdate:currentPage": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pageNum) = $event)),
            "page-size": _ctx.pageSize,
            "onUpdate:pageSize": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pageSize) = $event)),
            "page-sizes": [10, 30, 50, 100],
            layout: "total, sizes, prev, pager, next, jumper",
            total: _ctx.total,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.initTableList
          }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ])
      ]),
      (_ctx.isRecharge)
        ? (_openBlock(), _createBlock(_component_popupRecharge, {
            key: 0,
            ref: "rechargeRef",
            onClose: _ctx.onCloseRecharge,
            useWay: "InsureRechargePeriodDaily",
            onDetermine: _ctx.onSaveRecharge,
            dataTitle: "安心日保充值"
          }, null, 8, ["onClose", "onDetermine"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.isTransfer,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isTransfer) = $event)),
        title: "转账",
        width: "30%",
        "before-close": _ctx.onCloseTransfer
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_51, [
            _createVNode(_component_el_button, { onClick: _ctx.onCloseTransfer }, {
              default: _withCtx(() => _cache[53] || (_cache[53] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onSaveTransfer
            }, {
              default: _withCtx(() => _cache[54] || (_cache[54] = [
                _createTextVNode(" 提交 ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_49, [
            _cache[52] || (_cache[52] = _createElementVNode("div", { class: "title bold mg-b-20" }, "转账到安心保险（元）", -1)),
            _createElementVNode("div", _hoisted_50, [
              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "font-large bold" }, "¥", -1)),
              _createVNode(_component_el_input, {
                class: "ipt",
                modelValue: _ctx.transferNum,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.transferNum) = $event)),
                onInput: _ctx.onChangeNum,
                type: "number",
                maxlength: "9",
                placeholder: "请输入充值金额"
              }, null, 8, ["modelValue", "onInput"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "before-close"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.isAddInsure,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.isAddInsure) = $event)),
        title: "加保",
        width: "450px",
        "before-close": _ctx.onCloseAddInsure
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_52, [
            _createVNode(_component_el_button, { onClick: _ctx.onCloseAddInsure }, {
              default: _withCtx(() => _cache[56] || (_cache[56] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onSaveAddInsure
            }, {
              default: _withCtx(() => _cache[57] || (_cache[57] = [
                _createTextVNode(" 提交 ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              model: _ctx.formAddInsure,
              ref: "ruleAddInsureRef",
              rules: _ctx.addInsureRules,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "保险方案",
                  prop: "planCode"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formAddInsure.planCode,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formAddInsure.planCode) = $event)),
                      placeholder: "请选择保险方案",
                      onChange: _ctx.onPlanChange,
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: index
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "派遣单位",
                  prop: "companyId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formAddInsure.companyId,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formAddInsure.companyId) = $event)),
                      placeholder: "请选择派遣单位",
                      onChange: _ctx.onCompanyChange,
                      disabled: !_ctx.formAddInsure.planCode,
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.value,
                            key: index
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                (_ctx.formAddInsure.companyId)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "工种",
                      prop: "workType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formAddInsure.workType,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formAddInsure.workType) = $event)),
                          placeholder: "工种",
                          clearable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workTypeList, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.label,
                                value: item.value,
                                key: index
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "保单截止时间",
                  prop: "date"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formAddInsure.date,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formAddInsure.date) = $event)),
                      type: "date",
                      style: {"width":"198px"},
                      class: "date-solt point",
                      "disabled-date": _ctx.handleDisableDate,
                      "unlink-panels": "",
                      placeholder: "生效日期",
                      format: "YYYY-MM-DD",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue", "disabled-date"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { style: {"margin-top":"-24px","color":"#9497B1","font-size":"12px"} }, {
                  default: _withCtx(() => _cache[55] || (_cache[55] = [
                    _createTextVNode(" 默认保障24小时，或者更换保障截止日期 ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "before-close"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.projectShow,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.projectShow) = $event)),
        title: "项目管理",
        width: "800px",
        "before-close": _ctx.onCloseProject
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.projectId,
                  class: "project-item"
                }, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_57, "创建时间：" + _toDisplayString(item.createTime), 1),
                    _createElementVNode("div", _hoisted_58, "创建人：" + _toDisplayString(item.createUserName), 1)
                  ]),
                  (item.isUsed == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, "使用中"))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "project-item-btn project-item-btn-no",
                        onClick: ($event: any) => (_ctx.onUseProject(item))
                      }, " 使用", 8, _hoisted_60))
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "before-close"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.addProjectShow,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.addProjectShow) = $event)),
        title: "添加项目",
        width: "400px",
        "before-close": _ctx.onCloseAddProject
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_61, [
            _createVNode(_component_el_button, { onClick: _ctx.onCloseAddProject }, {
              default: _withCtx(() => _cache[58] || (_cache[58] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onSaveAddProject
            }, {
              default: _withCtx(() => _cache[59] || (_cache[59] = [
                _createTextVNode(" 确定 ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              model: _ctx.formAddProject,
              ref: "addProject",
              rules: _ctx.addProjectRules,
              "label-width": "80px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "项目名称",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formAddProject.name,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formAddProject.name) = $event)),
                      onKeydown: _cache[25] || (_cache[25] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                      maxlength: "20",
                      placeholder: "请输入项目名称",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "before-close"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showInsureRate,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.showInsureRate) = $event)),
        title: _ctx.titleTip,
        width: "420px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_65, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.closeInsureCompanyRate
            }, {
              default: _withCtx(() => _cache[60] || (_cache[60] = [
                _createTextVNode(" 知道了 ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_ctx.increaseData.changeState === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _createTextVNode(" 您好!根据您当前保单的理赔率情况，我们已按照《日日保+安心日保理赔率过高保费上调规则》对您的保费费率进行了调整:当前理赔率:【" + _toDisplayString(_ctx.increaseData.currentRate) + "%】，调整后费率上涨【 ", 1),
                  _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.increaseData.increaseRate) + "%", 1),
                  _createTextVNode("】，于【" + _toDisplayString(_ctx.increaseData.effectDate) + " 23:45】，按新费率扣次24小时和次日保费，本次调整是为了保障产品长期稳定运营，确保您的保障服务不受影响。 ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.increaseData.changeState === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, " 恭喜您，根据您当前保单的理赔率情况，我们已按照《日日保+安心日保理赔率过高保费上调规则》对您的保费费率进行了调整:当前理赔率:【" + _toDisplayString(_ctx.increaseData.currentRate) + "%】(已降至 100% 以内)，调整后保费已恢复、当晚按原保费扣除次24小时和次日保费。本次调整是对您良好风险表现的肯定，我们将持线为您提供稳定、可靠的保障服务。 ", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      (_ctx.isAddInsureDrawer)
        ? (_openBlock(), _createBlock(_component_addInsure, {
            key: 1,
            showDrawer: _ctx.isAddInsureDrawer,
            baseInfo: _ctx.baseInfo,
            projectId: _ctx.projectId,
            onCloseDrawer: _ctx.onCloseDrawer
          }, null, 8, ["showDrawer", "baseInfo", "projectId", "onCloseDrawer"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_feeRateNotice, {
      show: _ctx.showNotice,
      "onUpdate:show": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.showNotice) = $event))
    }, null, 8, ["show"])
  ], 64))
}